import { styled } from '@mui/material';
import { ListItemContainer } from 'shared/_components/list/styles';

export const ProjectListItemContainer = styled(ListItemContainer, { name: 'ProjectListItemContainer' })(({ theme }) => ({
	display: 'grid',
	alignItems: 'center',
	columnGap: theme.spacing(2),
	gridTemplateColumns: '1fr max-content',
	gridTemplateAreas: `
		"title icons"
		"info icons"
	`,
	[theme.breakpoints.up('md')]: {
		gridTemplateColumns: '1fr minmax(185px, 1fr) max-content',
		gridTemplateAreas: `
			"title id icons"
			"info id icons"
		`,
	},
	[theme.breakpoints.up('lg')]: {
		gridTemplateColumns: '1fr 1fr minmax(185px, 1fr) max-content',
		gridTemplateAreas: `
			"title title id icons"
			"info tags id icons"
		`,
	},
}));
